export default __webpack_public_path__ + "static/media/Kale-Closeup-800px.jpg.bcabf64e.webp";